module.exports = __webpack_public_path__ + "img/task-management-coin.f9e53ec.webp";